export enum DamageQueryKey {
  GetDamageRecordingFormData = 'getDamageRecordingFormData'
}
